<template>
  <div class="images-list-widget">
    <div class="images-list">
      <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="is_loading" :is-full-page="false"
        :can-cancel="false" background-color="#f9f9f9" class="loader"></loading>
      <div class="image-item" v-for="(item, index) in unsplash_images" :key="index" @click="addImage(item.urls.regular)">
        <img :src="item.urls.thumb" class="image-thumbs" />
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  name: "editor-menu",
  components: {},
  props: {
    account_type: {
      type: String,
      default: "school",
    },
  },
  data() {
    return {
      unsplash_images: [],
      is_loading: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
    vm.getUnsplashImages();
  },
  methods: {
    getUnsplashImages() {
      let vm = this;
      vm.is_loading = true;
      vm.$store
        .dispatch("GET_IMAGES_FROM_UNSPLASH")
        .then((response) => {
          vm.is_loading = false;
          vm.unsplash_images = response.data;
        })
        .catch((error) => {
          vm.is_loading = false;
        });
    },
    addImage(url) {
      let vm = this;
      vm.$emit("setImage", url);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.images-list-widget {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .images-list {
    height: 100%;
    overflow-y: auto;
    display: grid;
    grid-template-columns: 48% 48%;
    grid-gap: 20px;
    position: relative;

    .image-item {
      display: flex;
      background: #ddd;
      border-radius: 5px;
      cursor: pointer;

      .image-thumbs {
        height: 170px;
        width: 100%;
        object-fit: cover;
        border-radius: 5px;
      }
    }
  }
}
</style>